import { memo } from 'react';
import { CARDBACKS, RANK_SYM, SUIT_CLS, SUIT_SYM } from '@aleaces/engine';
import type { Card } from '@aleaces/protocol';

/** Memoised: the match screen re-renders on every snapshot and timer tick,
 * but a card's props only change when it is dealt, flipped or highlighted. */
export const CardView = memo(function CardView({
  card, up, lg, dealing, dim, hl, cardback, delayMs,
}: {
  card: Card | null;
  up: boolean;
  lg?: boolean;
  dealing?: boolean;
  dim?: boolean;
  hl?: boolean;
  cardback: string;
  delayMs?: number;
}) {
  const cb = CARDBACKS.find((b) => b.id === cardback) ?? CARDBACKS[0]!;
  const cls = [
    'card',
    card ? SUIT_CLS[card.s] : '',
    lg ? 'lg' : '',
    up && card ? 'up' : '',
    dealing ? 'dealing' : '',
    dim ? 'dim' : '',
    hl ? 'hl' : '',
  ].filter(Boolean).join(' ');
  return (
    <div className={cls} style={delayMs ? { animationDelay: delayMs + 'ms' } : undefined}>
      <div className="inner">
        <div className="face front">
          {card && (
            <>
              <span className="rk">{RANK_SYM[card.r]}</span>
              <span className="big">{SUIT_SYM[card.s]}</span>
              <span className="st">{SUIT_SYM[card.s]}</span>
            </>
          )}
        </div>
        <div className="face back" style={{ background: cb.css }} />
      </div>
    </div>
  );
});
